function iaInitCollectorsEdition() {
  var root = document.querySelector('[data-ia-ce]');
  if (!root || root.dataset.iaInited) return;
  root.dataset.iaInited = '1';

  var WALNUT = '#3B2417', LINEN = '#D8CABD';
  var assetBase = (document.currentScript && document.currentScript.dataset.assetBase) || '';

  var editions = [
    {
      no: '07', total: '20', release: 'The Mnemosyne Edition', img: root.dataset.imgMnemosyne,
      leather: 'Deep Walnut', size: 'A5 Trifold', avail: 'low', remaining: '6 of 20 remaining',
      perso: 'Engraving available',
      story: 'An edition devoted to memory — chocolate leather, a gold iris clasp, and an enclosed antique photograph, numbered and signed by hand.',
    },
    {
      no: '03', total: '15', release: 'The Sappho Edition', img: root.dataset.imgSappho,
      leather: 'Wax Seal Red', size: 'A6 Trifold', avail: 'low', remaining: '4 of 15 remaining',
      perso: 'Not available',
      story: 'A poetic deep-red release with lace and brass detailing, conceived as a single complete design and never reproduced.',
    },
    {
      no: '11', total: '12', release: 'The Hypatia Edition', img: root.dataset.imgHypatia,
      leather: 'Ink Black', size: 'A5 Bifold', avail: 'last', remaining: '2 of 12 remaining',
      perso: 'Engraving / hot foil',
      story: 'Our most architectural edition — ink-black full-grain leather, restrained hardware, and a quietly numbered spine.',
    },
  ];

  var active = 0;

  function statusFor(e) { return e.avail === 'last' ? 'Final pieces' : 'Limited'; }

  function render() {
    var ed = editions[active];

    root.querySelector('[data-ia-ce-image]').style.backgroundImage = "url('" + ed.img + "')";
    root.querySelector('[data-ia-ce-no]').textContent = ed.no;
    root.querySelector('[data-ia-ce-total]').textContent = '/ ' + ed.total;
    root.querySelector('[data-ia-ce-avail]').textContent = ed.remaining;
    root.querySelector('[data-ia-ce-release-caption]').textContent = ed.release;
    root.querySelector('[data-ia-ce-release]').textContent = ed.release;
    root.querySelector('[data-ia-ce-story]').textContent = ed.story;

    var specs = [
      ['Edition No.', ed.no + ' / ' + ed.total],
      ['Release', ed.release],
      ['Leather', ed.leather],
      ['Size', ed.size],
      ['Availability', ed.remaining],
      ['Personalisation', ed.perso],
    ];
    var specsEl = root.querySelector('[data-ia-ce-specs]');
    specsEl.innerHTML = '';
    specs.forEach(function (s) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:baseline;justify-content:space-between;gap:16px;padding:14px 2px;border-bottom:1px solid #D8CABD;';
      row.innerHTML = '<span style="font-size:11.5px;letter-spacing:0.16em;text-transform:uppercase;color:#8a7a64;flex-shrink:0;">' + s[0] + '</span>' +
        '<span style="font-family:\'Cormorant\',serif;font-size:19px;color:#2A160D;text-align:right;">' + s[1] + '</span>';
      specsEl.appendChild(row);
    });

    var archiveEl = root.querySelector('[data-ia-ce-archive]');
    archiveEl.innerHTML = '';
    editions.forEach(function (e, i) {
      var on = i === active;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.style.cssText = 'display:block;width:100%;text-align:left;cursor:pointer;background:#F4F0E8;padding:16px 16px 22px;font-family:inherit;transition:all .2s;' +
        (on ? 'border:1.5px solid ' + WALNUT + ';box-shadow:0 6px 22px rgba(58,36,23,0.14);' : 'border:1px solid ' + LINEN + ';');
      btn.innerHTML =
        '<span style="display:block;width:100%;height:260px;background:url(\'' + e.img + '\') center / cover no-repeat;"></span>' +
        '<span style="display:flex;align-items:center;justify-content:space-between;margin:18px 2px 0;">' +
        '<span style="font-size:11px;letter-spacing:0.2em;text-transform:uppercase;color:#A77742;">No. ' + e.no + ' / ' + e.total + '</span>' +
        '<span style="font-size:10.5px;letter-spacing:0.1em;text-transform:uppercase;color:' + (e.avail === 'last' ? '#9A3B2A' : '#8a7a64') + ';">' + statusFor(e) + '</span>' +
        '</span>' +
        '<span style="display:block;font-family:\'Cormorant\',serif;font-size:25px;color:#2A160D;text-align:left;margin:8px 2px 0;">' + e.release + '</span>' +
        '<span style="display:block;font-size:13.5px;color:#6f5d48;text-align:left;margin:4px 2px 0;">' + e.leather + ' &middot; ' + e.size + '</span>';
      btn.addEventListener('click', function () {
        active = i;
        render();
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (err) {}
      });
      archiveEl.appendChild(btn);
    });
  }

  render();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iaInitCollectorsEdition); else iaInitCollectorsEdition();
document.addEventListener('shopify:section:load', iaInitCollectorsEdition);
